import { useLocation, useRoutes } from 'react-router-dom'

import { SnackBar } from '@shared-ui/components'

import { useNotification } from 'app/providers'
import { getSnackBarClassNames, useLanguageRefetch } from 'shared/lib'

import { protectedRoutes } from './protectedRoutes'
import { publicRoutes } from './publicRoutes'

const PUBLIC_PATHS = new Set([
    '/login',
    '/sign-up',
    '/forgot-password',
    '/password-recovery',
    '/verification-success',
])

function isPublicRoute(pathname: string): boolean {
    const normalized = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
    return PUBLIC_PATHS.has(normalized)
}

function isAuthenticated(): boolean {
    const token =
        localStorage.getItem('accessToken') ??
        sessionStorage.getItem('accessToken')
    if (!token) return false

    const userRaw =
        localStorage.getItem('user') ?? sessionStorage.getItem('user')
    if (!userRaw) return false

    try {
        const user = JSON.parse(userRaw) as { isVerified?: boolean }
        return user.isVerified === true
    } catch {
        return false
    }
}

export const AppRoutes = () => {
    const location = useLocation()
    const { notifications, hideNotification } = useNotification()

    const isPublic = isPublicRoute(location.pathname)
    const routes =
        !isPublic && isAuthenticated() ? protectedRoutes : publicRoutes

    const element = useRoutes(routes)

    useLanguageRefetch()

    return (
        <>
            <div>{element}</div>
            {notifications?.notification?.msg && (
                <SnackBar
                    rootClasses={getSnackBarClassNames()}
                    id="notification"
                    open={!!notifications?.notification}
                    variant={notifications?.notification?.type}
                    delay={2450}
                    notificationMessage={notifications?.notification?.msg}
                    onDismiss={() => hideNotification('notification')}
                />
            )}
        </>
    )
}
